{
  "id": 41,
  "location": "paris",
  "difficulty": "normal",
  "moves": 26,
  "kinds": 6,
  "goals": [
    { "type": "collect", "kind": "donut", "count": 36 },
    { "type": "collect", "kind": "latte", "count": 36 }
  ],
  "stars": [4420, 5460],
  "board": [
    "# # . . . . # #",
    "# . . . . . . #",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    "# . . . . . . #",
    "# # . . . . # #"
  ],
  "calibration": { "runs": 1000, "winRate": 0.705, "movesLeft": 4.8, "closeLosses": 0.118, "target": 0.68 }
}
